import { Alert, Box, Typography } from '@mui/material';
import {
  closeSnackbar,
  SnackbarKey,
  SnackbarMessage,
  VariantType,
} from 'notistack';
import { forwardRef, ReactNode } from 'react';

import Icon from 'components/@icons/Icon';

interface Props {
  message: SnackbarMessage;
  variant: VariantType;
  action: ReactNode;
  id: SnackbarKey;
}

const Snackbar = forwardRef<HTMLDivElement, Props>(
  ({ message, variant, action, id }, ref) => {
    if (variant === 'seatsTimer') {
      return (
        <Box
          onClick={() => closeSnackbar(id)}
          ref={ref}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            borderRadius: 2,
            bgcolor: 'grey.900',
            border: '1px solid',
            borderColor: 'grey.800',
            px: 2,
            py: 1,
            mt: '-6px',
          }}
        >
          <Icon name="Timer" color="secondary.main" />
          <Typography variant="extraSmall">{message}</Typography>
        </Box>
      );
    }
    return (
      <Alert
        severity={
          variant === 'default' || variant === 'transferSuccess'
            ? 'success'
            : variant
        }
        onClick={() => closeSnackbar(id)}
        action={action}
        ref={ref}
      >
        {message}
      </Alert>
    );
  },
);

Snackbar.displayName = 'Snackbar';

export default Snackbar;
